import React from 'react';
import { Button } from 'react-bootstrap';
import routes from '../../../../utils/routes';

type NeedAnAccountProps = {
  isLoading?: boolean;
  className?: string;
};

const NeedAnAccount: React.FC<NeedAnAccountProps> = (props) => {
  const {
    isLoading,
    className = '',
  } = props;

  return (
    <div className={`need-an-account ${className}`}>
      <p className="text-muted">
        Need an account?
      </p>

      <Button
        variant="lancaster-yellow"
        type="button"
        onClick={() => {
          // If the login modal is open, close it and open the register modal
          // Otherwise, just open the register modal
          // @ts-ignore
          if ($('#loginModal').hasClass('show')) {
            $('#loginModal')
              .modal('hide')
              .on('hidden.bs.modal', () => {
                $('#registerModal').modal('show');
              });
          } else {
            $('#registerModal').modal('show');
          }
        }}
        disabled={isLoading}
        className="px-5"
      >
        Sign up
      </Button>

      <div className="mt-3">
        <a
          href={routes.TERMS_OF_SERVICE_GET}
          target="_blank"
          className="btn btn-sm text-muted btn-link"
          rel="noreferrer"
        >
          Terms of use
        </a>
        <a
          href={routes.PRIVACY_POLICY_GET}
          target="_blank"
          className="btn btn-sm text-muted btn-link"
          rel="noreferrer"
        >
          Privacy Policy
        </a>
      </div>
    </div>
  );
};

export default NeedAnAccount;
